export const GET_SCHOOL_BY_ID = 'school/GET_SCHOOL_BY_ID';
export const UPDATE_SCHOOL_BY_ID = 'school/UPDATE_SCHOOL_BY_ID';
